import supportLink from 'constants/support'
import includes from 'lodash/includes'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import URL from 'url-parse'

import { languagePrefixes } from '../providers/ConnectedIntl/languages'

const localize = (value: string, language: string, isPathname: boolean) => {
  const url = new URL(value)
  const urlArray = url.pathname.split('/').filter((path) => !isEmpty(path))
  const potentialPrefix = urlArray[0]
  const langPrefix = includes(languagePrefixes, potentialPrefix) ? potentialPrefix : undefined

  switch (true) {
    case isNil(langPrefix) && language !== 'en':
      urlArray.unshift(language)
      break
    case !isNil(langPrefix) && language === 'en':
      urlArray.shift()
      break
    case !isNil(langPrefix) && language !== 'en':
      urlArray.shift()
      urlArray.unshift(language)
      break
    default:
      break
  }

  const newUrl = url.set('pathname', urlArray.join('/'))

  return isPathname ? newUrl.pathname + newUrl.query : newUrl.href
}

export const localizeUrl = (href: string, language: string) => localize(href, language, false)

export const getSupportLink = (locale: string, path = ''): string => {
  const mappedLocale = locale === 'zh' ? 'zh-cn' : locale
  return `${supportLink}/${mappedLocale}${path}`
}
